import { Flex, Text } from '@sendoutcards/quantum-design-ui'
import React, { FC } from 'react'
import { Icon } from 'src/design_system/atoms/icons/components/Icon'
import { IconType } from 'src/design_system/atoms/icons/types'
import { useSelector } from 'src/hooks'

export type TabProps = {
  title: string
  onClick: () => void
  icon?: IconType
  isActive?: boolean
  notificationCount?: number
  hideText?: boolean
  showLeftDivider?: boolean
  radius?: string
  activeTabBackgroundColor?: string
  activeTabTextColor?: string
  tabBarBackground?: string
  textSize?: string
  insetVertical?: string
  shouldHideText?: boolean
}

export const Tab: FC<TabProps> = ({
  title,
  isActive,
  icon,
  notificationCount,
  hideText = false,
  radius = '10px',
  onClick,
  activeTabBackgroundColor = '#FFF',
  activeTabTextColor = '#404040',
  tabBarBackground = '#f5f6f7',
  textSize,
  insetVertical = 'x1',
  shouldHideText = false,
}) => {
  const tabTextColor = isActive ? activeTabTextColor : '#616161'
  const isSmallMobile = useSelector(state => state.window.width < 400)
  const badgeText =
    notificationCount && notificationCount > 0
      ? notificationCount > 10
        ? '10+'
        : String(notificationCount)
      : null

  return (
    <Flex
      boxShadow={isActive ? 'mediumLight' : ''}
      position="relative"
      inset={{
        vertical: insetVertical,
        horizontal: isActive
          ? isSmallMobile
            ? 'x2'
            : 'x2_5'
          : isSmallMobile
            ? '10px'
            : 'x1_5',
      }}
      borderRadius={radius}
      backgroundColor={isActive ? activeTabBackgroundColor : tabBarBackground}
      onClick={onClick}
      cursor={'pointer'}
      justifyContent="center"
      alignItems="center"
      style={{ boxShadow: isActive ? '0px 4px 8px 0px rgb(0 0 0 / 7%)' : '' }}
    >
      {badgeText ? (
        <Flex
          position="absolute"
          top="-10px"
          right="-10px"
          backgroundColor="#BE9CDD"
          color="inverseHeading"
          borderRadius="999px"
          justifyContent="center"
          alignItems="center"
          style={{
            padding: '1px 10px',
            fontFamily: 'Montserrat, sans-serif',
            fontSize: 12,
            lineHeight: '18px',
            height: 22,
            minWidth: 22,
          }}
        >
          {badgeText}
        </Flex>
      ) : null}
      <Flex alignItems="center" columnGap="x_75">
        {icon && <Icon name={icon} size={20} color={tabTextColor} />}
        {!shouldHideText && !hideText && (
          <Text
            type="caption"
            weight={isActive ? 'bold' : 'regular'}
            content={title}
            whiteSpace="nowrap"
            color={isActive ? 'primaryHeading' : 'primaryBody'}
            style={{
              lineHeight: 'initial',
              color: tabTextColor,
              fontSize: textSize,
            }}
          />
        )}
      </Flex>
    </Flex>
  )
}
